import { FormGroup, Radio, RadioGroup } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { supplyCategoriesByEpisodeCategory } from '@common/constants/supplyCategoriesByEpisodeCategory';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrderSuppliesFormState } from '../../types/orderSuppliesFormState';
import type { OrderSuppliesRouteParams } from '../../types/orderSuppliesRouteParams';
import { routeParamToEpisodeCategory, routeParamToSupplyCategory } from '../../utils/orderSuppliesRouteUtils';

export function OrderSuppliesOrderAmount() {
    const { episodeCategory: episodeCategoryParam, supplyCategory: supplyCategoryParam } =
        useParams() as OrderSuppliesRouteParams;
    const form = useFormContext<OrderSuppliesFormState>();

    const episodeCategory = episodeCategoryParam ? routeParamToEpisodeCategory(episodeCategoryParam) : undefined;
    const supplyCategory = supplyCategoryParam ? routeParamToSupplyCategory(supplyCategoryParam) : undefined;

    if (!episodeCategory || !supplyCategory) {
        return null;
    }

    const amount = supplyCategoriesByEpisodeCategory[episodeCategory]?.[supplyCategory]?.amount;

    if (amount && amount.length > 0) {
        return (
            <FormGroup
                isRequired={true}
                label="Aantal zakjes"
            >
                <RadioGroup
                    error={form.errors.getMessage('order.amount')}
                    layout="column"
                    name="order.amount"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.order.amount ?? ''}
                >
                    {amount.map((amountOption) => (
                        <Radio
                            disabled={form.isSubmitting}
                            key={amountOption}
                            label={amountOption.toString()}
                            value={amountOption.toString()}
                        />
                    ))}
                </RadioGroup>
            </FormGroup>
        );
    }

    return null;
}
